import React, { FunctionComponent, useEffect, useRef } from 'react';
import { BetterBeWidgetPayload } from '../../services/betterBe/betterBePayload.model';
import { debugLog } from '../../services/common/miscUtils';
import { mapBetterBeToWebCalcRequest } from '../../services/webCalc/mapBetterBeToWebCalcRequest';
import { validateWebCalcRequest } from '../../services/webCalc/webCalcRequest.validator';

interface WebCalcProps {
  betterBePayload?: BetterBeWidgetPayload | null;
}

export const WebCalc: FunctionComponent<WebCalcProps> = ({ betterBePayload }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (!betterBePayload) {
      debugLog({ level: 'ERROR', message: '[WebCalc] no BetterBe configuration available; widget not initialised.' });
      return;
    }

    const CalculatorCtor = (window as any).Calculator;
    if (typeof CalculatorCtor !== 'function') {
      debugLog({ level: 'ERROR', message: '[WebCalc] calculator.js not loaded; widget not initialised.' });
      return;
    }

    const calculator = new CalculatorCtor({ WEBCALC_API_URL: process.env.REACT_APP_WEB_CALC_API_URL });

    const request = mapBetterBeToWebCalcRequest(betterBePayload);

    // Logs mismatches via debugLog and never throws — the widget is loaded regardless.
    validateWebCalcRequest(request);

    calculator.getInterface(request, { ResultContainer: container });
  }, [betterBePayload]);

  return <div id="calculator" ref={containerRef} />;
};
